export default __webpack_public_path__ + "static/media/sections_thumb.3df6196f.jpg";